import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setJobOperatorsOperation = (state, { jobOperatorsOperationData }) => {
  if (!jobOperatorsOperationData) return state;
  return state.merge({ jobOperatorsOperationData });
};

const setJobOperatorsOperationLoaderStatus = (state, { jobOperatorOperationsLoader }) => {
  return state.merge({ jobOperatorOperationsLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_JOB_OPERATORS_OPERATION,
    actionFunction: setJobOperatorsOperation,
  },
  {
    actionType: ActionTypes.SET_JOB_OPERATORS_OPERATION_LOADER_STATUS,
    actionFunction: setJobOperatorsOperationLoaderStatus,
  },
];
